import React from "react";
import styled from "styled-components";
import { Row, Col } from "react-bootstrap";

import { hexToRGBA } from "../../../../../utils/theme";
import { FORM_FIELD_KEYS } from "../../../../../constants/forms";
import { getFieldProps } from "../../../../../utils/form-fields";

import TextInput from "../../../controls/TextInput";

const StyledContainer = styled.div`
  margin-bottom: 24px;
`;

const StyledRow = styled(Row)`
  margin-top: 1rem;
  margin-bottom: 2rem;
  margin-right: 0;
  margin-left: 0;
  padding: 16px;
  border: 2px solid #797c7f;
`;

function SoleProprietorInfoBlock({ values = {}, onChange, onMouseEnter, onMouseLeave }) {
  return (
    <StyledContainer>
      <div className="inputs-block-title">
        <span>Sole Proprietor Information</span>
      </div>
      <StyledRow>
        <Col xs={12}>
          <TextInput
            {...getFieldProps(FORM_FIELD_KEYS.dbaname)}
            label={getFieldProps(FORM_FIELD_KEYS.dbaname)?.placeholder?.replace("*", "")}
            placeholder={undefined}
            value={values[FORM_FIELD_KEYS.dbaname]}
            onChange={onChange}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            hideDivider
          />
        </Col>
      </StyledRow>
    </StyledContainer>
  );
}

export default SoleProprietorInfoBlock;
